import React from 'react';
import { useFormContext } from 'react-hook-form';

import { CampaignType, EarningRuleType } from '../../../config/CustomEnums';
import { removeDuplicatesByFieldFromArray } from 'utils';

import './ApprovalCheckList.scss';
import { LinkButtonSection } from 'components/base/LinkSection';
import ErrorFieldMessage, { errorMessage, hasError } from 'components/base/ErrorFieldMessage';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { SectionTopTitle } from 'components/base/CommonComponent';

function ApprovalCheckList() {
  const { watch, setValue, formState: { errors }, getValues } = useFormContext();
  const checkListField = "checkList";
  const checkList = watch(checkListField) || {}

  const campaignType = getValues('campaignType')
  const linkedCoupon = getValues('linkedCoupon')
  const linkedEarningRules = getValues('linkedEarningRules')
  const stampLinkedEarningRules = getValues('stampLinkedEarningRules');
  const stampRewards = getValues('stampRewards')
  const ticketCampaignLinkedCoupons = watch('ticketCampaignTimeSlots');

  const linkedEarningRulesReward = (earningRule) => {
    switch (earningRule?.type) {
      case EarningRuleType.birthday:
        return earningRule.birthdayTypeCouponRewardTypeCouponTemplate
      case EarningRuleType.fillingForm:
        return earningRule.fillingFormTypeCouponRewardTypeCouponTemplate
      case EarningRuleType.generalPurchase:
        return earningRule.generalPurchaseTypeCouponRewardTypeCouponTemplate
      case EarningRuleType.gpsCheckIn:
        return earningRule.gpsCheckInTypeCouponRewardTypeCouponTemplate
      case EarningRuleType.memberReferral:
        return earningRule.memberReferralTypeCouponRewardTypeCouponTemplate
      case EarningRuleType.newMember:
        return earningRule.newMemberTypeCouponRewardTypeCouponTemplate
      case EarningRuleType.qrCodeScanning:
        return earningRule.qrCodeScanningTypeCouponRewardTypeCouponTemplate
      default:
        return earningRule?.couponTemplate || null
    }
  }

  console.log("@23", campaignType)
  console.log("@50", errors)
  const addNewCheckList = (item) => {
    if (!item || checkList?.[item?.id] !== undefined) {
      return
    }
    setValue(checkListField, { ...checkList, [item.id]: false })
  }
  const item = (item, pathRoot) => {
    addNewCheckList(item)
    const showError = hasError(errors, checkListField) && !checkList?.[item?.id]
    return (
      <div className={`check-list-item-container`}>
        <label className={`checkbox-container check-list-label`}>
          {`[ID: ${item?.pk}] ${item?.name}`}
          <input type="checkbox" checked={checkList?.[item?.id]} onChange={(e) => {
            console.log("@67", checkList)
            const newCheckList = {
              ...checkList,
              [item.id]: !checkList?.[item?.id]
            }
            setValue(checkListField, newCheckList, { shouldDirty: true })
          }} />
          <span className={showError ? 'checkmark error-field' : 'checkmark'}></span>
        </label>
        <LinkButtonSection
          link={`${pathRoot}/${item?.pk}/edit`}
          linkText={'Go to review'}
          disableLink={pathRoot === "/coupons" && item?.toDelete}
          disableLinkText="Deleted"
        />
        <ErrorFieldMessage error={showError} id={item?.id} message={errorMessage(errors, checkListField)} />
      </div>)
  }

  const stampCampaignRelatedCoupon = () => {
    let stampRewardsCouponList = []
    stampRewards.forEach((value) => {
      value?.linkedCoupon && stampRewardsCouponList.push(value?.linkedCoupon)
    })
    stampRewardsCouponList = removeDuplicatesByFieldFromArray(stampRewardsCouponList, "id")

    if (stampRewardsCouponList.length > 0) {
      return (
        <>
          <CustomTitleLabel title={'Related coupon set'} />
          {stampRewardsCouponList.map((coupon) => item(coupon, '/coupons'))}
        </>
      )
    }
    return null
  }

  return (
    <>
      <div id={checkListField} /> {/* error hook*/}
      <SectionTopTitle title={'Checklist'} />
      {campaignType === CampaignType.ticketCampaign && 
      <>
        <CustomTitleLabel title={'Link to coupon set (ticket type)'} />
        {ticketCampaignLinkedCoupons?.map(value => value?.couponSet?.pk ? item(value.couponSet, '/coupons') : null )}
      </>
      }
      
      {campaignType === CampaignType.couponsCampaign ? <>
        <CustomTitleLabel title={'Related coupon set'} />
        {item(linkedCoupon, '/coupons')}
      </> : null}

      {campaignType === CampaignType.earningRulesCampaign ?
        <>
          {linkedEarningRulesReward(linkedEarningRules) ? <>
            <CustomTitleLabel title={'Related coupon set'} />
            {item(linkedEarningRulesReward(linkedEarningRules), '/coupons')}
          </> : null}
          <CustomTitleLabel title={'Related earning rule'} />
          {item(linkedEarningRules, '/earns')}
        </>
        : null}

      {campaignType === CampaignType.stampCampaign ? <>
        {stampCampaignRelatedCoupon()}
        <CustomTitleLabel title={'Related earning rule'} />
        {
          stampLinkedEarningRules.map((value) => item(value, '/earns'))
        }
      </> : null}
    </>
  );
}

export default ApprovalCheckList;
